import _extends from "@babel/runtime/helpers/extends";
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import { mergeWdsBoxColorProps, resolveWdsBoxColorProps, wdsThemeColors } from '@wix/rules-panel-ui';
import React, { useMemo } from 'react';
import { useA11yWizardAdapter } from '../../../../hooks/use-a11y-wizard-adapter';
import MediaAlternativeRuleThumbnail from './media-alternative-rule-thumbnail';
const isYouTubeUrl = url => {
  return Boolean(url == null ? void 0 : url.startsWith('https://www.youtube.com/watch?v='));
};
export const MediaAlternativesRuleHeader = _ref => {
  let {
    title,
    disabled = false,
    sourceType,
    uri
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const softIssueListSurfaces = capabilities.wizardPresentation.softIssueListSurfaces;
  const titleToShow = useMemo(() => {
    if (title) {
      return title;
    }
    if (isYouTubeUrl(uri)) {
      return t('accessibility-wizard.rules-list.media-alternatives.default-youtube-title');
    }
    return t('accessibility-wizard.rules-list.media-alternatives.default-media-title');
  }, [title, uri, t]);
  const thumbnailSurfaceProps = softIssueListSurfaces ? {
    border: '1px solid',
    ...mergeWdsBoxColorProps(resolveWdsBoxColorProps(wdsThemeColors.borderStandardDark, 'borderColor'), resolveWdsBoxColorProps(wdsThemeColors.surfaceNeutral))
  } : {
    backgroundColor: 'D75',
    border: '1px solid',
    borderColor: 'D60'
  };
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    cursor: disabled ? 'default' : 'pointer',
    gap: "SP3",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, _extends({
    align: "center",
    borderRadius: "4px",
    flexShrink: 0,
    height: "30px",
    verticalAlign: "middle",
    width: "30px"
  }, thumbnailSurfaceProps), /*#__PURE__*/React.createElement(MediaAlternativeRuleThumbnail, {
    sourceType: sourceType,
    uri: uri
  })), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    maxLines: 2,
    size: "tiny",
    ellipsis: true
  }, titleToShow)));
};
//# sourceMappingURL=media-alternatives-rule-header.js.map